import emptyBackground from "../../assets/images/cardBgWaves.png";
import bgUrl from "../../assets/images/topographie.svg";
import {CardBgImage, CardImage, DestinationImage} from "./styles.js";

export const ImgContent = ({
  isImg,
  imageUrl,
  isDestinationCard,
  ImgTitle,
  altImgText,
  postTitle,
}) => {
  return isImg ? (
    isDestinationCard ? (
      <DestinationImage
        src={imageUrl}
        title={ImgTitle || "card image"}
        alt={altImgText || postTitle}
        loading="lazy"
      />
    ) : (
      <CardImage
        src={imageUrl}
        title={ImgTitle || "card image"}
        alt={altImgText || postTitle}
        loading="lazy"
      />
    )
  ) : (
    <CardBgImage
      src={isDestinationCard ? emptyBackground : bgUrl}
      alt="Default background"
      loading="lazy"
    />
  );
};
